import { ofType, ActionsObservable } from 'redux-observable';
import { mergeMap, flatMap } from 'rxjs/operators';
import { from } from 'rxjs';
import {format} from 'one-util-date';
import {
    ErrorObject
} from 'one-state-error/src/errorobject';

import {
    addAction as addErrorAction
} from 'one-state-error/src/actions';
import { InvokeFinesseProxy } from '../../subject/src/index';

export const enum Types {
    PUSH_CALL_RECORD = 'push-call-record',
}

/**
 * This Function posts data to pushcalldatarecord api
 * @param context contains settings.json etc...
 */
export const pushCallRecord = (context: any) => (
    (action$: ActionsObservable<any>) => {
        const errorTime = format(new Date(), 'LT');
        const errorDate = format(new Date(), 'LL');
        const { server,
            log,
            alertnotification,
            settings:
            {
                servers,
                compatible,
                epicendpoints: { apitoken, pushcalldatarecord },
                soucetypelookup
            }
        } = context;
        const { finesse_proxy_service } = compatible;
        const { locations = [] } = servers;
        return action$.pipe(
            ofType(Types.PUSH_CALL_RECORD),
            mergeMap((action: any) => {
                /**
                 * @param dataresponse contains the patient global search request
                 */
                const dataresponse: any = action.payload;
                log.debug("one-epics", "push-call-record request", dataresponse);
                const postPushCallRecord = (payload: any) => {
                    let headers = new Headers();
                    headers.set('Authorization', 'Basic ' + apitoken?.token);
                    let response;
                    if (finesse_proxy_service) {
                        response = InvokeFinesseProxy(pushcalldatarecord, payload, apitoken, locations, log, 'POST', alertnotification);

                    } else {
                        response = server.post({
                            headers,
                            path: pushcalldatarecord,
                            data: payload,
                        }).then((responsefound: any) => responsefound)
                            .catch((responseresult: any) => {
                                log.error("one-epic", "push-call-record Error", responseresult);
                                let pgserror: ErrorObject = {
                                    source: "Push Call Record",
                                    type: "error",
                                    status: responseresult?.status,
                                    erroritems: responseresult?.errors,
                                    error_date: errorDate,
                                    error_time: errorTime
                                };
                                return pgserror;
                            })
                        log.debug("one-epics", "push-call-record response", response);
                    }
                    return from(response);
                }
                return postPushCallRecord(dataresponse).pipe(
                    flatMap((response: any) => {
                        const actions: any = [];

                        if (response && (response.status >= 400 || response.type == "error")) {
                            actions.push(addErrorAction(response));
                        }

                        return actions;
                    })
                )
            })
        )
    }

);